import { tieneSorbyIa, rutaCaja } from './cuentaSorbyIa';
import { FRASE_RECORRIDO_COMPLETO, accionesPendientes } from './recorrido';

export const CLAVE_CAJA_VISTA = 'caja_vista';
export const EVENTO_HITO = 'sorby-ia:hito';

// Cada pantalla que el chat comenta: la ruta, la acción del recorrido que completa y el mensaje fijo (no lo redacta el modelo).
const GUIAS_DE_PANTALLA = [
  {
    ruta: '/cajas',
    clave: CLAVE_CAJA_VISTA,
    mensaje: 'Esta es tu caja: acá ves cada movimiento con su foto y podés filtrar por obra, fecha o categoría.',
  },
];

// Acciones cuyo recorrido pasa por otra pantalla: el chat ofrece un botón que lleva hasta ahí.
const ENLACES_DE_ACCION = {
  [CLAVE_CAJA_VISTA]: { etiqueta: 'Abrir mi caja', ruta: rutaCaja },
};

const sinQuery = (ruta) => String(ruta || '').split(/[?#]/)[0];

export const guiaDePantalla = (ruta) => GUIAS_DE_PANTALLA.find((g) => g.ruta === sinQuery(ruta)) || null;

export const mensajeDeGuia = (ruta) => guiaDePantalla(ruta)?.mensaje ?? null;

export const enlaceDeAccion = (clave, empresaId) => {
  const enlace = ENLACES_DE_ACCION[clave];
  return enlace && empresaId ? { etiqueta: enlace.etiqueta, ruta: enlace.ruta(empresaId) } : null;
};

// Solo cuenta en onboarding con la acción todavía pendiente, y una sola vez por sesión.
export const debeRegistrarHito = ({ empresa, onboarding, clave, registrados }) =>
  tieneSorbyIa(empresa) &&
  onboarding?.activo === true &&
  (onboarding.pasos || []).some((p) => p.clave === clave && !p.completo) &&
  !registrados?.has(clave);

// Con la acción en curso, al llegar a su pantalla el chat la comenta y vuelve a preguntar qué sigue.
export const avisoDeGuia = ({ clave, enCurso, actual, ruta }) => {
  const guia = guiaDePantalla(ruta);
  if (!guia || guia.clave !== clave || enCurso !== clave) return null;
  const quedan = accionesPendientes(actual).length > 0;
  return { texto: quedan ? guia.mensaje : `${guia.mensaje} ${FRASE_RECORRIDO_COMPLETO}`, claves: [clave] };
};

export const avisarHito = (clave) => {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENTO_HITO, { detail: { clave } }));
};
